"use client";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import ArrowLink from "../molecules/ArrowLink";
export default function CustomerSolutions(props) {
    var _useState = _sliced_to_array(useState(props.tabs[0]), 2), selectedTab = _useState[0], setSelectedTab = _useState[1];
    //const currentTabIndex = props.tabs.indexOf(selectedTab);
    var _useState1 = _sliced_to_array(useState(350), 2), maxHeight = _useState1[0], setMaxHeight = _useState1[1];
    var mainRef = useRef(null);
    useEffect(function() {
        var _Math;
        var _mainRef_current;
        var heights = Array.from(((_mainRef_current = mainRef.current) === null || _mainRef_current === void 0 ? void 0 : _mainRef_current.querySelectorAll(".tab-body")) || []).map(function(el) {
            return el.getBoundingClientRect().height;
        });
        setMaxHeight((_Math = Math).max.apply(_Math, _to_consumable_array(heights)));
    }, [
        selectedTab
    ]);
    // const handlePrevTab = () => {
    //   const prevIndex =
    //     (currentTabIndex - 1 + props.tabs.length) % props.tabs.length;
    //   setSelectedTab(props.tabs[prevIndex]);
    // };
    //
    // const handleNextTab = () => {
    //   const nextIndex = (currentTabIndex + 1) % props.tabs.length;
    //   setSelectedTab(props.tabs[nextIndex]);
    // };
    return /*#__PURE__*/ React.createElement("div", {
        className: "px-6 md:px-14 pb-6 md:pb-16 lg:pb-20 relative lg:pt-28 lg:-mt-24 overflow-hidden"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-7xl relative"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "mx-auto text-center max-w-xs md:max-w-md lg:max-w-lg block text-2xl md:text-3xl lg:text-4xl mb-10 md:mb-16"
    }, props.heading), /*#__PURE__*/ React.createElement("div", {
        className: "pb-14"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "relative z-20 lg:flex lg:gap-x-11"
    }, /*#__PURE__*/ React.createElement("nav", {
        className: 'lg:w-1/3 order-last relative lg:pb-6 before:lg:content-[""] before:lg:block before:lg:w-1 before:lg:h-full before:lg:bg-gray-10 before:lg:absolute before:lg:-bottom-px before:lg:-left-4'
    }, /*#__PURE__*/ React.createElement("ul", {
        className: "flex md:block"
    }, props.tabs.map(function(tab, key) {
        /*#__PURE__*/ return React.createElement("li", {
            key: key,
            onClick: function() {
                setSelectedTab(tab);
            },
            className: clsx('w-full mb-6 md:mb-0 relative top-px cursor-pointer hover:text-gray-600 before:content-[""] before:block before:absolute before:bottom-0 before:md:-translate-y-1/2 before:lg:transform-none before:md:bottom-[unset] before:md:top-1/2 before:lg:top-0 before:left-0 before:lg:-left-4 before:transition-all before:md:h-2/3 before:lg:h-full before:md:w-1 before:h-1 before:w-full md:border-b md:border-b-gray-400 last:border-none font-heading flex items-center text-[0px] md:text-base lg:text-lg transition-all flex-1', {
                "text-gray-600 before:bg-yellow-500": tab === selectedTab,
                "bg-transparent text-gray-200 before:bg-transparent before:lg:bg-gray-10": tab !== selectedTab
            })
        }, /*#__PURE__*/ React.createElement("button", {
            className: "flex items-center justify-center md:justify-start w-full py-5 px-2.5 sm:px-1.5 md:px-6 lg:px-3.5 focus focus-visible:-outline-offset-4 focus-visible:outline-black"
        }, /*#__PURE__*/ React.createElement("img", {
            className: clsx("grayscale max-h-[17px] sm:max-h-[27px] max-w-[54px] sm:max-w-[75px] sm:mr-4", {
                "opacity-40": tab !== selectedTab
            }),
            src: "".concat(tab === null || tab === void 0 ? void 0 : tab.logo),
            alt: "".concat(tab === null || tab === void 0 ? void 0 : tab.company),
            loading: "lazy"
        }), /*#__PURE__*/ React.createElement("span", null, tab === null || tab === void 0 ? void 0 : tab.company)));
    }))), /*#__PURE__*/ React.createElement("main", {
        className: "max-[1023px]:!min-h-[unset] lg:w-2/3",
        ref: mainRef,
        style: {
            minHeight: "".concat(maxHeight, "px")
        }
    }, /*#__PURE__*/ React.createElement(AnimatePresence, {
        mode: "wait"
    }, /*#__PURE__*/ React.createElement(motion.div, {
        key: selectedTab ? selectedTab.company : "empty",
        initial: {
            y: 10,
            opacity: 0
        },
        animate: {
            y: 0,
            opacity: 1
        },
        exit: {
            y: -10,
            opacity: 0
        },
        transition: {
            duration: 0.2
        },
        className: "h-full tab-body min-h-full"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "lg:flex lg:flex-row-reverse lg:gap-x-11 h-full"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full rounded-l-2xl border h-full border-gray-200 relative bg-white p-8 pb-20 md:p-10"
    }, /*#__PURE__*/ React.createElement("img", {
        height: "36",
        className: "max-h-[36px] max-w-full mb-5",
        src: "".concat(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.logo),
        alt: "".concat(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.company),
        loading: "lazy"
    }), /*#__PURE__*/ React.createElement("blockquote", null, /*#__PURE__*/ React.createElement("p", {
        className: "mb-6 md:mb-3 leading-snug md:text-2xl font-semibold font-heading"
    }, selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.quote), /*#__PURE__*/ React.createElement("cite", {
        className: "not-italic text-xs md:w-2/5 block md:pr-8"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "block mb-0.5"
    }, selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.source), /*#__PURE__*/ React.createElement("span", {
        className: "block text-[#777777]"
    }, selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.role))), /*#__PURE__*/ React.createElement(ArrowLink, {
        text: "Read success story",
        target: (selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.target) || "/",
        className: "absolute rounded-bl-2xl md:rounded-none bottom-0 right-0 md:w-3/5 px-8 md:px-7 py-4 bg-gray-10 w-full focus-visible:outline-black focus-visible:-outline-offset-2"
    })))))), /*#__PURE__*/ React.createElement(ArrowLink, {
        text: "Read more",
        target: "/customers",
        className: "absolute md:rounded-none -bottom-10 lg:-bottom-1 right-0 focus-visible:outline-black focus-visible:-outline-offset-2"
    }))), /*#__PURE__*/ React.createElement(SvgBg, null)), /*#__PURE__*/ React.createElement("div", {
        className: 'before:lg:content-[""] before:lg:block before:lg:bg-gray-30 before:lg:absolute before:lg:top-px before:lg:-left-[22%] before:lg:2xl:-left-[19%] before:lg:3xl:-left-[12.7%] before:lg:4xl:-left-[8%] before:lg:5xl:-left-[6%] before:lg:w-1/3 before:lg:h-[479px]'
    }));
}
function SvgBg() {
    return /*#__PURE__*/ React.createElement("svg", {
        width: "507px",
        height: "481px",
        viewBox: "0 0 507 481",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        className: "hidden lg:block z-10 absolute -top-28 -left-14"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Homepage",
        transform: "translate(52.000000, -1584.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "BG-Panel",
        transform: "translate(-52.000000, 1584.550270)"
    }, /*#__PURE__*/ React.createElement("polygon", {
        id: "Gray-Cutout-Panel",
        fill: "#F7F9FB",
        transform: "translate(279.500000, 240.000000) scale(1, -1) rotate(-180.000000) translate(-279.500000, -240.000000) ",
        points: "52 343.01676 407.306214 -7.10542736e-13 507 -1.27897692e-12 507 480 52 480"
    }), /*#__PURE__*/ React.createElement("g", {
        id: "Bit-Pattern/Gray",
        transform: "translate(0.000000, 191.000000)",
        fill: "#F0F2F2"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(361.000000, 73.000000) rotate(-180.000000) translate(-361.000000, -73.000000) ",
        x: "352",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(137.000000, 201.000000) rotate(-180.000000) translate(-137.000000, -201.000000) ",
        x: "128",
        y: "192",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(201.000000, 201.000000) rotate(-180.000000) translate(-201.000000, -201.000000) ",
        x: "192",
        y: "192",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(265.000000, 201.000000) rotate(-180.000000) translate(-265.000000, -201.000000) ",
        x: "256",
        y: "192",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(169.000000, 169.000000) rotate(-180.000000) translate(-169.000000, -169.000000) ",
        x: "160",
        y: "160",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(233.000000, 169.000000) rotate(-180.000000) translate(-233.000000, -169.000000) ",
        x: "224",
        y: "160",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(265.000000, 169.000000) rotate(-180.000000) translate(-265.000000, -169.000000) ",
        x: "256",
        y: "160",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(137.000000, 137.000000) rotate(-180.000000) translate(-137.000000, -137.000000) ",
        x: "128",
        y: "128",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(201.000000, 137.000000) rotate(-180.000000) translate(-201.000000, -137.000000) ",
        x: "192",
        y: "128",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(73.000000, 105.000000) rotate(-180.000000) translate(-73.000000, -105.000000) ",
        x: "64",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(137.000000, 105.000000) rotate(-180.000000) translate(-137.000000, -105.000000) ",
        x: "128",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(201.000000, 105.000000) rotate(-180.000000) translate(-201.000000, -105.000000) ",
        x: "192",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(329.000000, 105.000000) rotate(-180.000000) translate(-329.000000, -105.000000) ",
        x: "320",
        y: "96",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(297.000000, 73.000000) rotate(-180.000000) translate(-297.000000, -73.000000) ",
        x: "288",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(41.000000, 73.000000) rotate(-180.000000) translate(-41.000000, -73.000000) ",
        x: "32",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(105.000000, 73.000000) rotate(-180.000000) translate(-105.000000, -73.000000) ",
        x: "96",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(265.000000, 73.000000) rotate(-180.000000) translate(-265.000000, -73.000000) ",
        x: "256",
        y: "64",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(265.000000, 41.000000) rotate(-180.000000) translate(-265.000000, -41.000000) ",
        x: "256",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(9.000000, 41.000000) rotate(-180.000000) translate(-9.000000, -41.000000) ",
        x: "0",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(105.000000, 41.000000) rotate(-180.000000) translate(-105.000000, -41.000000) ",
        x: "96",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(169.000000, 41.000000) rotate(-180.000000) translate(-169.000000, -41.000000) ",
        x: "160",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(233.000000, 41.000000) rotate(-180.000000) translate(-233.000000, -41.000000) ",
        x: "224",
        y: "32",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(41.000000, 9.000000) rotate(-180.000000) translate(-41.000000, -9.000000) ",
        x: "32",
        y: "0",
        width: "18",
        height: "18",
        rx: "9"
    }), /*#__PURE__*/ React.createElement("rect", {
        id: "Bit",
        transform: "translate(233.000000, 9.000000) rotate(-180.000000) translate(-233.000000, -9.000000) ",
        x: "224",
        y: "0",
        width: "18",
        height: "18",
        rx: "9"
    }))))));
}
